import { render, staticRenderFns } from "./home-button.component.vue?vue&type=template&id=705cac3f&scoped=true"
import script from "./home-button.component.vue?vue&type=script&lang=ts"
export * from "./home-button.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cac3f",
  null
  
)

export default component.exports